import { StatusId } from '../../types';

// Predicats PURS sur l'id_status d'une commande (offre prestataire) dans l'Analyse.
// Tout est indexe sur l'id de statut (seeder), jamais sur le nom ni sur un prefixe
// d'historique. Source unique reutilisee par la notation, le scoring et la synthese.

// 7/8/9/10 = ballet de signature du mode AUTOMATIQUE (acheteur/prestataire) — vivants selon
// le mode renvoye par l'API, pas obsoletes. Une offre dans ces etats = "Signature en cours".
const SIGNATURE_EN_COURS: number[] = [
  StatusId.ASigner,
  StatusId.EnAttenteSignaturePrestataire,
  StatusId.EnAttenteSignatureAcheteur,
  StatusId.ASignerPrestataire,
];

export const isExpire = (idStatus?: number): boolean => idStatus === StatusId.Expirer; // 12

export const isRefuse = (idStatus?: number): boolean => idStatus === StatusId.Refuser; // 6

export const isAccepte = (idStatus?: number): boolean => idStatus === StatusId.Valider; // 11

export const isPending = (idStatus?: number): boolean =>
  idStatus !== undefined && SIGNATURE_EN_COURS.includes(idStatus);

// Offre EN LICE pour la notation / le score / l'attribution : ni refusee (6) ni expiree (12).
// Corrige le bug legacy qui ne filtrait que !== 12 (un refus pouvait etre note, voire gagner).
export const isOffreValide = (idStatus?: number): boolean =>
  !isRefuse(idStatus) && !isExpire(idStatus);

// Colonne masquee dans les grilles (sauf si acceptee/en signature, qui restent affichees
// en lecture seule). Memes ids que isOffreValide -> un seul jeu de regles pour affichage + scoring.
export const isOffreMasquee = (idStatus?: number): boolean =>
  !isAccepte(idStatus) && !isPending(idStatus) && (isExpire(idStatus) || isRefuse(idStatus));
